export const orderModule = {
    cancel: "Cancel",
    pay: "Pay",
    chose_pay_type:"Please select a payment method",
    phone:"Phone",
    desc1:"将门票URL发送到以下手机号码或者Email",
    pay_title:"Pay",
    to_pay:"ToPay",
    agree:"Agree",
    policy:"Privacy Policy",
    total:"Total",
    use_point:"Use scenic spots",
    use_point_code:"Please scan the QR code when using",
    code:"Code",
    used_point:"Already utilized attractions",
    more:"More",
    input:"Please fill in the necessary information",
    pay_type:"Please select a payment method",
    isCancel:"Should I cancel?",
    sure:"Sure",
    pay_success:"Thank you for your purchase",
    pay_cancel:"Successful cancellation",
    pay_fail:"Payment failure",
    pay_cancel1:"Cancelled",
    pay_wait:"Payment results are pending",
    status1:"Wait for payment",
    status2:"Can use",
    status3:"Completed",
    status4:"Expired",
    status5:"Refunded",
    status6:"Cancel",
    selectBookFun: "Selection mode",
    inputBookPlaceholder: "Please enter the invoice title",
    inputMemoPlaceholder: 'Please fill in the remarks',
    getBook: "Invoice title",
    comment: "Comment",
    comment_star: "Degree of satisfaction",
    comment_contentHolder: "Please write down your evaluatio",
    comment_noStar: "Please select degree of satisfaction",
    comment_noContent: "Comment content cannot be empty",
    comment_submitSuccess: "Successfully commented",
    comment_replay: "Merchant reply",
    comment_uploadSuccess: "Successfully upload",
    comment_moreImg: "Up to 4 pictures can be uploaded",
    comment_sizeImg: "The image cannot be larger than 5M",
};

export default orderModule;